import { ITranslations } from "../types"

export const AppTranslations: ITranslations = {
  i18n: (key: string) => App.Text.get2(key),
}
